<template>
  <div class="input-textfield-root">
    <div
      :class="{
        'input-textfield-container': true,
        readonly,
        focus,
        error: !validFlag,
      }"
    >
      <input
        ref="input"
        :max="type == 'date' ? maxDate : null"
        :value="value"
        :placeholder="placeholder"
        @keydown="onKeydown"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
        @keyup="onKeyUp"
        :type="type"
        :readonly="readonly"
        :maxlength="maxlength"
      />
      <img
        v-if="append"
        @mousedown="onClickIcon"
        :src="append"
        class="icon-append"
        :width="appendWidth"
      />
    </div>
    <div v-if="!validFlag && errorMessage" class="text-error">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    transform: {
      type: Function,
      default: v => v,
    },
    onblurTransform: {
      type: Function,
      default: v => v,
    },
    maxlength: {
      type: Number,
      default: null,
    },
    append: {
      type: String,
      default: '',
    },
    appendWidth: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
      default: () => [],
    },
    maxDate: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      text: this.value,
      focus: false,
      isBackspace: false,
      validFlag: true,
    };
  },
  watch: {
    value(val) {
      this.text = val;
    },
    error(val) {
      this.validFlag = !val;
    },
  },
  mounted() {
    if (this.value) {
      this.text = this.value;
    }
    if (this.error) {
      this.validFlag = !this.error;
    }
  },
  methods: {
    onKeydown(e) {
      if (e.code === 'Backspace' || e.key === 'Backspace') {
        this.isBackspace = true;
      }
    },
    onInput(e, isBlur) {
      let text = e.target.value;
      if (
        this.type === 'number' &&
        this.maxlength !== null &&
        !!text &&
        text.length > this.maxlength
      ) {
        text = text.substring(0, text.length - 1);
      }
      text = this.transform(text, this.isBackspace, isBlur);
      this.isBackspace = false;
      e.target.value = text;
      this.text = text;
      this.valid();
      this.$emit('input', text);
      this.$emit('onupdate');
    },
    valid() {
      if (this.rules.length) {
        this.validFlag = true;
        for (const rule of this.rules) {
          const result = rule(this.text);
          if (result === false || typeof result === 'string') {
            this.validFlag = false;
            break;
          }
        }
        return this.validFlag;
      }
      return true;
    },
    onKeyUp(e) {
      this.$emit('keyup', e);
    },
    onFocus() {
      this.focus = true;
      this.$emit('focus');
    },
    onBlur() {
      this.focus = false;
      this.onInput({ target: { value: this.text } }, true);
      this.text = this.onblurTransform(this.text);
      this.valid();
      this.$emit('input', this.text);
      this.$emit('onupdate');
      this.$emit('blur');
    },
    onClickIcon() {
      // this.$refs.input.click();

      this.$emit('append');
    },
  },
};
</script>

<style lang="scss" scoped>
.input-textfield-root {
  .input-textfield-container {
    display: flex;
    align-items: center;
    color: var(--surface-high);
    font-size: 20px;
    border-radius: 8px;
    border: 1px solid var(--gray-300);
    min-height: 64px;

    input {
      padding: 0 24px;
      width: 100%;
      height: 62px;
      outline: none;
      color: var(--surface-high);
      -webkit-appearance: none; // for hide default icon

      &::-webkit-date-and-time-value {
        text-align: left;
      }

      // for hide default icon
      &::-webkit-inner-spin-button,
      &::-webkit-calendar-picker-indicator {
        display: none;
        -webkit-appearance: none;
      }
    }

    &.focus {
      border-color: var(--primary-80);
      box-shadow: 0px 2px 8px 4px rgba(95, 101, 255, 0.05);
      filter: drop-shadow(0px 0px 8px rgba(95, 101, 255, 0.1));
      border-radius: 8px;
    }

    &.readonly {
      background-color: var(--gray-100);
      border: 1px solid var(--surface-disabled);

      input {
        color: var(--surface-medium);
      }
    }

    &.error {
      border-color: var(--error-100);
    }

    .icon-append {
      margin-right: 29px;
      cursor: pointer;
    }
  }

  .text-error {
    margin-top: 8px;
    font-size: 12px;
    line-height: 12px;
    color: var(--error-100);
    inline-size: max-content;
  }
}
</style>
